import React from 'react';
import cx from 'classnames';
import { Link } from 'gatsby';

const Button = ({ as = 'button', externalLink = false, to, children, modifier, size, block = false, className, ...props }) => {
  const buttonClass = 'btn';

  const HTMLElement = to ? (externalLink ? 'a' : Link) : as;
  const linkProps = to ? (externalLink ? { href: to } : { to: to }) : {};

  return (
    <HTMLElement
      className={cx(
        buttonClass,
        modifier,
        size,
        {
          'btn--block': block,
        },
        className
      )}
      {...linkProps}
      {...props}
    >
      {children}
    </HTMLElement>
  );
};

export default Button;
